import { ethers as o } from "ethers";
import { HODLTokenContractAbi as e } from "@deorderbook/contracts/abi";
import { sellTokenHODLAddress as s, uHODLAddress as c } from "@deorderbook/contracts";
import { signer as d, provider as i } from "./provider.mjs";
const m = (t) => ({
  sellTokenHODL: s,
  uHODL: c
})[t], a = (t) => new o.Contract(
  m(t),
  e
), L = (t, r = !1) => {
  const n = a(t);
  return r ? n.connect(d) : n.connect(i);
};
export {
  a as initHODLContract,
  L as useHODLContract
};
//# sourceMappingURL=hodlContract.mjs.map
